import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseDatePicker from './ExpenseDatePicker';
import { COLORS } from '../../../utils/Application_Constants';
import { ValidationModeContext } from '../../../contexts/VendorPaymentValidationModeContext';
import { useContext } from 'react';
import moment from 'moment/moment';

const PayrollDate = (props) => {
    const { index, expense, isRequired = false, isViewOnly = false } = props;
    const { control, errors } = useFormContext();
    const validationMode = useContext(ValidationModeContext);

    return (
        <Grid2 item size={{ xs: 12, md: 6 }}>
            <Controller
                control={control}
                disabled={isViewOnly}
                name={`expenseEntries[${index}].payrollDate`}
                defaultValue={expense.payrollDate || null}
                rules={{
                    validate: (value) => {
                        if (
                            (validationMode === 'submit' && !value && isRequired) ||
                            (isRequired && !value)
                        ) {
                            return 'Payroll Date is required. Please enter a valid date.';
                        }
                        return true;
                    },
                }}
                render={({ onChange, value }) => (
                    <ExpenseDatePicker
                        onChange={onChange}
                        disabled={isViewOnly}
                        value={value ? moment(value) : null}
                        id={`payroll-date-${index}`}
                        label="Payroll Date"
                        required={isRequired}
                        parentTextFieldProps={{
                            error: Boolean(errors.expenseEntries?.[index]?.payrollDate),
                            helperText: errors.expenseEntries?.[index]?.payrollDate?.message,
                        }}
                        parentSx={{
                            '& .MuiInputBase-root': {
                                borderColor: !errors.expenseEntries?.[index]?.payrollDate
                                    ? 'default'
                                    : `${COLORS.LT_PEPPER} !important`,
                            },
                        }}
                    />
                )}
            />
        </Grid2>
    );
};

export default PayrollDate;
